import type { Node, NodeProps } from '@xyflow/react';
import type { FunctionComponent } from 'react';
import type { HelperLineNodeData } from '../../interfaces';

export type HelperLineNodeType = Node<HelperLineNodeData, 'helperLineNode'>;

export const HelperLineNode: FunctionComponent<NodeProps<HelperLineNodeType>> = ({ data }) => {
    const { axis, length, color, thickness } = data;

    const isVertical = axis === 'x';
    const width = isVertical ? thickness : length;
    const height = isVertical ? length : thickness;

    return (
        <div
            style={{
                width,
                height,
                background: color,
                position: 'relative',
                pointerEvents: 'none',
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    left: isVertical ? '50%' : 0,
                    top: isVertical ? 0 : '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: 12,
                    color,
                    userSelect: 'none',
                }}
            >
                ✕
            </div>
            <div
                style={{
                    position: 'absolute',
                    left: isVertical ? '50%' : length,
                    top: isVertical ? length : '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: 12,
                    color,
                    userSelect: 'none',
                }}
            >
                ✕
            </div>
        </div>
    );
};
